import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <pre><code parentName="pre" {...{
        "className": "language-sql"
      }}>{`SELECT 
    COUNT(*) 
FROM 
    stripe_customer 
WHERE 
    metadata.is_current_startup_plan_customer = 'true' 
    AND metadata.startup_plan_label != 'YC'
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      